import { useEffect, useRef, useState } from 'react';

const useIsTruncated = () => {
    const ref = useRef(null);
    const [isTruncated, setIsTruncated] = useState(false);
    useEffect(() => {
        const checkTruncation = () => {
            if (ref.current) {
                setIsTruncated(ref.current.scrollWidth > ref.current.clientWidth);
            }
        };
        checkTruncation();
        window.addEventListener('resize', checkTruncation);
        return () => window.removeEventListener('resize', checkTruncation);
    }, []);
    return { ref, isTruncated };
};

export default useIsTruncated;
